import type { Notification } from "@/store/slices/notificationsTypes";
import type { ShowToastOptions } from "./show-unified-toast";

/**
 * The toast for a "Call / Recording" officer notice (joinNoticeAlerts.server writes it; the bell already holds it, so
 * the toast must not add a second entry). Null for every other notification.
 */
export function recordingNoticeToastFor(notification: Notification): ShowToastOptions | null {
  if (notification.category !== "call") return null;
  const meta = notification.metadata as { topic?: unknown; kind?: unknown } | undefined;
  if (meta?.topic !== "recording_notice") return null;
  const missing = meta.kind === "missing";
  return {
    variant: missing ? "warning" : "info",
    title: notification.title,
    categoryLabel: "Call / Recording",
    duration: missing ? 10_000 : 5_000,
    alreadyRecorded: true,
    id: `recording-notice-${notification.id}`,
  };
}
